const I = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMWM2LjA3NSAwIDExIDQuOTI1IDExIDExcy00LjkyNSAxMS0xMSAxMVMxIDE4LjA3NSAxIDEyIDUuOTI1IDEgMTIgMXptMCAyYTkgOSAwIDEgMCAwIDE4IDkgOSAwIDAgMCAwLTE4em0zLjI5MyA1LjI5M2wxLjQxNCAxLjQxNEwxMCAxNi40MTRsLTMuNzA3LTMuNzA3IDEuNDE0LTEuNDE0TDEwIDEzLjU4Nmw1LjI5My01LjI5M3oiICBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=";
export {
  I as default
};
//# sourceMappingURL=success-336820b4.mjs.map
